// extracted by mini-css-extract-plugin
module.exports = {"overlay":"TimedOut_overlay__1VM9p","content":"TimedOut_content__3_uLh","container":"TimedOut_container__7Pz9X"};